export enum UploadType {
	Claims = "claims",
	DeviceRecords = "deviceRecords",
	Forms = "forms",
	Records = "records",
}

export enum CreateType {
	ClaimRecord = "Claim Record",
	PurchaseRecord = "purchase-record"
}